module.exports = __webpack_public_path__ + "img/545.8a7d795d.jpg";